import { useEffect, useState } from "react";
import { Megaphone, Mail } from "lucide-react";
import { useI18n } from "../i18n";
import { api } from "../lib/api";

export const useInbox = () => {
  const [messages, setMessages] = useState([]);
  useEffect(() => { api.get("/me/messages").then((r) => setMessages(r.data)); }, []);
  const markRead = (m) => {
    if (m.read) return;
    api.post(`/me/messages/${m.id}/read`);
    setMessages((list) => list.map((x) => (x.id === m.id ? { ...x, read: true } : x)));
  };
  return { messages, markRead, unread: messages.filter((m) => !m.read).length };
};

export const Inbox = ({ messages, markRead }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(null);
  if (!messages.length) return <div className="lux-card p-10 text-center text-muted-foreground" data-testid="inbox-empty">{t("inbox_empty")}</div>;
  return (
    <div className="lux-card divide-y" data-testid="inbox-list">
      {messages.map((m) => {
        const Icon = m.broadcast ? Megaphone : Mail;
        return (
          <button key={m.id} onClick={() => { setOpen(open === m.id ? null : m.id); markRead(m); }} className="block w-full p-5 text-left transition-colors hover:bg-accent/50" data-testid={`inbox-item-${m.id}`}>
            <div className="flex items-start gap-4">
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full" style={{ background: "var(--gold-soft)" }}><Icon className="h-4 w-4" style={{ color: "var(--gold)" }} /></span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <p className={`truncate ${m.read ? "font-medium" : "font-bold"}`}>{m.title}</p>
                  <span className="rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-wider text-muted-foreground">{m.broadcast ? t("msg_broadcast") : t("msg_personal")}</span>
                  {!m.read && <span className="rounded-full px-2 py-0.5 text-[10px] font-bold uppercase" style={{ background: "var(--gold)", color: "#0A0D14" }} data-testid={`inbox-new-${m.id}`}>{t("msg_new")}</span>}
                </div>
                <p className="mt-1 text-xs text-muted-foreground">{new Date(m.created_at).toLocaleString()}</p>
                <p className={`mt-2 whitespace-pre-line text-sm text-muted-foreground ${open === m.id ? "" : "line-clamp-1"}`} data-testid={`inbox-body-${m.id}`}>{m.body}</p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
